export const environment = {
  version: '1.36a',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
